import processor from './processor';
import { GeneratorPanel, GenerationInfoPanel, PromptPanel, GeneratorElements, wrapImageOverlayer } from './components';
import {
  submitGeneration,
  resumeGeneration,
  registerGenerateParamsHandler,
  registerGenerateResultHandler,
} from './helpers/generate';

export default {
  type: 'generator',

  methods: { submitGeneration, resumeGeneration, registerGenerateParamsHandler, registerGenerateResultHandler },

  setup: async ({ app }) => {
    app.extension.registerProcessor(processor.type, processor);

    app.extension.wrapElement('image', { overlayer: wrapImageOverlayer });

    app.extension.registerComponent('right_panel', {
      Component: GeneratorPanel,
      config: {
        name: 'generator',
      },
    });
    app.extension.registerComponent('bottom_panel', { Component: PromptPanel });
    app.extension.registerComponent('element_info_panel', { Component: GenerationInfoPanel });

    app.extension.registerRootElement('upper', { Component: GeneratorElements });
  },
};
